import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Eye = createReactComponent("Eye", ["svg", defaultAttributes, [["path", {
  d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z",
  key: "1t2h7b"
}], ["circle", {
  cx: "12",
  cy: "12",
  r: "3",
  key: "n6u7h6"
}]]]);
export default Eye;